
import { Component, Prop, Vue } from "vue-property-decorator";
import t from "@common/src/i18n/t";
@Component({
  model: {
    prop: "isExpand",
    event: "click"
  }
})
export default class ExpandControl extends Vue {
  @Prop({ default: () => t("v210801.expand-detail") })
  expandText: string;
  @Prop({ default: () => t("v210801.packup-detail") })
  closeText: string;
  @Prop({ default: false })
  isExpand: boolean;
  @Prop({ default: "top" })
  position: boolean;
  @Prop({ default: false, type: Boolean })
  onlyShowIcon: boolean;
  get $checked() {
    return this.isExpand;
  }
  handleExpandOrder() {
    this.$emit("click", !this.isExpand);
  }
}
